import { defineComponent, ref, getCurrentInstance, SetupContext, computed, PropType } from 'vue';
import { Picture } from '~/api/topic';
import { PwaBridge } from '@/common/bridge';

export const PitureActionBarAppSetup = () => {
    const isLiked = ref(false);

    const handleDownloadAction = async (pictureDetail?: Picture | undefined) => {
        const pictureUrl = pictureDetail?.pic_origin_url;
        try {
            if (!pictureUrl) {
                return;
            }

            const res = await PwaBridge.saveMediaToAlbum({
                url: pictureUrl,
                mediaType: 'image',
            });
            console.log(res, 'res');
        } catch (error) {
            console.log(error, 'error');
        }
    };

    const handleLikeAction = () => {
        isLiked.value = !isLiked.value;
    };

    return {
        isLiked,

        handleLikeAction,
        handleDownloadAction,
    };
};
